import * as React from 'react'
import { connect } from 'react-redux'
import type { State } from 'types/redux'
import {
  togglePlaylistFilter,
  updatePlaylistReportParams,
} from '@disco/state-management/actions/ReportActions'
import { getContactsDropdownOptions } from '@disco/state-management/selectors/contacts'
import CustomDropdown from 'components/ui/dropdowns/custom-dropdown'
type DropdownOption = {
  label: string
  value: string
}
type OwnProps = {
  formKey: string
}

function mapStateToProps(state: State, ownProps: OwnProps): any {
  return {
    value: state.reports.playlistReport.form[ownProps.formKey],
    userDropdownOptions: getContactsDropdownOptions(state),
    csrfToken: state.user.csrfToken,
  }
}

function mapDispatchToProps(dispatch: any, ownProps: OwnProps): any {
  return {
    onChange(option: DropdownOption) {
      const value = option?.value || ''
      dispatch(
        value === ''
          ? togglePlaylistFilter(ownProps.formKey, false)
          : updatePlaylistReportParams({
              [ownProps.formKey]: value,
            }),
      )
    },
  }
}

class ReportContact extends React.Component<{
  value: string
  userDropdownOptions: Array<{
    label: string
    value: string
  }>
  onChange: (option: DropdownOption) => unknown
  placeholder: string
  disabled?: boolean
}> {
  render() {
    const { userDropdownOptions, placeholder, value, onChange, disabled } =
      this.props
    const selectOptions = [
      {
        label: 'All clients',
        value: '',
      },
      ...userDropdownOptions,
    ]
    return (
      <CustomDropdown
        value={!value ? '' : value}
        placeholder={placeholder}
        name="user"
        multi={false}
        options={selectOptions}
        onChange={onChange}
        disabled={disabled}
      />
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReportContact) as any
